import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, renderSlot as _renderSlot, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { RouterView } from "vue-router";
import BaseLayout from "./components/BaseLayout.vue";
import { CommonStore } from "./store/CommonStore"
import Toast from "./components/Toast.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const commonStore = CommonStore()


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseLayout, { id: "app" }, {
    default: _withCtx(() => [
      _createVNode(Toast, {
        modelValue: _unref(commonStore).getToast.showToast,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(commonStore).getToast.showToast) = $event)),
        message: _unref(commonStore).getToast.message,
        state: _unref(commonStore).getToast.state,
        timeout: _unref(commonStore).getToast.timeout
      }, null, 8 /* PROPS */, ["modelValue", "message", "state", "timeout"]),
      _createCommentVNode(" データ更新中 "),
      _createVNode(Toast, {
        modelValue: _unref(commonStore).getupDatingToast.showToast,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(commonStore).getupDatingToast.showToast) = $event)),
        message: _unref(commonStore).getupDatingToast.message,
        state: _unref(commonStore).getupDatingToast.state,
        timeout: _unref(commonStore).getupDatingToast.timeout,
        style: _normalizeStyle([_unref(commonStore).getToast.showToast ? 'top: 70px;' : 'top: 10px;'])
      }, null, 8 /* PROPS */, ["modelValue", "message", "state", "timeout", "style"]),
      _renderSlot(_ctx.$slots, "default", {}, () => [
        _createVNode(_unref(RouterView))
      ])
    ]),
    _: 3 /* FORWARDED */
  }))
}
}

})